import {
  IsString,
  IsPhoneNumber,
  IsNotEmpty,
  IsUUID,
  Length,
  IsNumberString,
} from 'class-validator';

import {
  REQUIRED_FIELD_VALIDATION_MESSAGE,
  SMS_CODE_LENGTH,
} from '../../constants';

export class RegisterAliDto {
  @Length(SMS_CODE_LENGTH, SMS_CODE_LENGTH, {
    message: 'Вы указали неверный код',
    groups: ['code-verify'],
  })
  @IsNumberString(
    {
      no_symbols: true,
    },
    {
      message: 'Вы указали неверный код',
      groups: ['code-verify'],
    },
  )
  @IsString({
    message: 'Вы забыли ввести код',
    groups: ['code-verify'],
  })
  @IsNotEmpty({
    message: 'Вы забыли ввести код',
    groups: ['code-verify'],
  })
  code: string;

  @IsPhoneNumber('RU', {
    message: 'Неверный номер телефона',
  })
  @IsString()
  @IsNotEmpty(REQUIRED_FIELD_VALIDATION_MESSAGE)
  phone?: string;

  @IsUUID()
  @IsString()
  @IsNotEmpty(REQUIRED_FIELD_VALIDATION_MESSAGE)
  passCode?: string;
}
